/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
export const WithNoScript = WixProGallery => props => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WixProGallery, props), /*#__PURE__*/React.createElement("noscript", null, /*#__PURE__*/React.createElement("style", null, `
            .pro-gallery-wix-wrapper {display: block !important;}
            .pro-gallery-wix-wrapper .gallery-item-container {opacity: 1 !important; display: block !important;}
          `)));
};
//# sourceMappingURL=withNoScript.js.map